document.addEventListener('DOMContentLoaded', function () {
  // .select-secの存在チェック
  const selectSec = document.querySelector('.select-sec');
  if (!selectSec) return; // .select-secがない場合は処理を終了

  // 定数
  const CONSTANTS = {
    MOBILE_BREAKPOINT: 736,
    SCROLL_THRESHOLD: 200,
    ANIMATION_DURATION: 300,
    FADE_DURATION: 400,
    INITIAL_DELAY: 500
  };

  // DOM要素の取得と存在チェック
  const elements = {
    header: document.querySelector('header'),
    selectSec: selectSec,
    midashi: selectSec.querySelector('.midashi'),
    itemSec: document.querySelector('.item-sec'),
    checkboxList: selectSec.querySelector('.checkbox-list'),
    closeBtn: selectSec.querySelector('.close'),
    checkboxes: document.querySelectorAll('input[name="designer"]'),
    items: document.querySelectorAll('.item'),
    brandHead: document.querySelector('.head')
  };

  // 必要な要素が存在するかチェック
  if (!elements.header || !elements.midashi || !elements.itemSec || !elements.checkboxList) {
    console.warn('Required elements are missing');
    return;
  }

  // 状態管理
  let isAnimating = false;
  let ticking = false;

  // PCのみのスクロール制御
  function updateFixedClass() {
    if (!elements.selectSec || !elements.header || !elements.midashi || !elements.itemSec) {
      return;
    }

    if (window.innerWidth > CONSTANTS.MOBILE_BREAKPOINT) {
      const scrollPos = window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = elements.header.offsetHeight;
      const selectSecOffset = elements.selectSec.getBoundingClientRect().top + window.pageYOffset;

      if (scrollPos + headerHeight >= selectSecOffset) {
        if (!elements.selectSec.classList.contains('is-fixed')) {
          elements.selectSec.classList.add('is-fixed');
          const midashiHeight = elements.midashi.offsetHeight;
          elements.itemSec.style.paddingTop = `${midashiHeight}px`;
        }
      } else {
        elements.selectSec.classList.remove('is-fixed');
        elements.itemSec.style.paddingTop = '0';
      }
    }
  }

  // スクロールイベントリスナー
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        const scrollPos = window.scrollY;

        // PCの場合のfixed制御
        updateFixedClass();

        // ヘッダーのスクロール状態更新（SPのselect-secはCSSのstickyで固定）
        if (scrollPos > CONSTANTS.SCROLL_THRESHOLD) {
          elements.header.classList.add('is-scrolled');
        } else {
          elements.header.classList.remove('is-scrolled');
        }

        ticking = false;
      });
      ticking = true;
    }
  });

  // アコーディオン制御
  function toggleAccordion() {
    if (window.innerWidth <= CONSTANTS.MOBILE_BREAKPOINT) {
      const willOpen = !elements.midashi.classList.contains('is-open');

      // 開く時、まだ画面トップ（ヘッダー直下）に固定されていなければ、
      // バーが固定される位置までスクロールしてから開く（パネルの見切れ防止）
      if (willOpen) {
        const headerH = elements.header.offsetHeight;
        const rectTop = elements.selectSec.getBoundingClientRect().top;
        if (rectTop > headerH + 1) {
          const target = window.pageYOffset + rectTop - headerH;
          window.scrollTo({ top: target, behavior: 'smooth' });
        }
      }

      elements.midashi.classList.toggle('is-open');
      $(elements.checkboxList).slideToggle(CONSTANTS.ANIMATION_DURATION);
    }
  }

  // アイテム更新処理
  async function updateItems(selectedBrand = null) {
    if (isAnimating) return;
    isAnimating = true;

    elements.brandHead.classList.add('fade-out');
    elements.brandHead.classList.remove('is-active');

    elements.items.forEach(item => {
      item.classList.add('fade-out');
    });

    await new Promise(resolve => setTimeout(resolve, CONSTANTS.FADE_DURATION));

    if (selectedBrand) {
      const selectedInfo = document.querySelector(`.brand-info[data-brand="${selectedBrand}"]`);
      if (selectedInfo) {
        elements.brandHead.querySelector('.name .en').textContent = selectedInfo.querySelector('.name .en').textContent;
        elements.brandHead.querySelector('.name .ja').textContent = selectedInfo.querySelector('.name .ja').textContent;
        elements.brandHead.querySelector('.description').textContent = selectedInfo.querySelector('.description').textContent;
      }
      elements.brandHead.classList.add('is-active');
      elements.brandHead.classList.remove('is-empty');
    } else {
      elements.brandHead.querySelector('.name .en').textContent = '';
      elements.brandHead.querySelector('.name .ja').textContent = '';
      elements.brandHead.querySelector('.description').textContent = '';
      elements.brandHead.classList.remove('is-active');
      elements.brandHead.classList.add('is-empty');
    }

    elements.items.forEach(item => {
      if (selectedBrand) {
        if (item.dataset.brand === selectedBrand) {
          item.classList.remove('hidden');
          requestAnimationFrame(() => {
            item.classList.remove('fade-out');
          });
        } else {
          item.classList.add('fade-out');
          item.classList.add('hidden');
        }
      } else {
        item.classList.remove('hidden');
        requestAnimationFrame(() => {
          item.classList.remove('fade-out');
        });
      }
    });

    requestAnimationFrame(() => {
      elements.brandHead.classList.remove('fade-out');
    });

    isAnimating = false;
  }

  // チェックボックスのイベントハンドラ
  elements.checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function (e) {
      // 他のチェックボックスを解除
      elements.checkboxes.forEach(cb => {
        if (cb !== e.target) cb.checked = false;
      });

      // アイテム更新
      updateItems(this.checked ? this.value : null);

      // SP時のスクロール処理
      if (window.innerWidth <= CONSTANTS.MOBILE_BREAKPOINT) {
        elements.midashi.classList.remove('is-open');
        $(elements.checkboxList).slideUp(CONSTANTS.ANIMATION_DURATION, () => {
          const headerHeight = elements.header.offsetHeight;
          const midashiHeight = elements.midashi.offsetHeight;
          const isFixed = elements.selectSec.classList.contains('is-fixed');

          // .headのmarginを取得
          const headMarginTop = parseInt(window.getComputedStyle(elements.brandHead).marginTop);

          let targetPosition;

          if (isFixed) {
            // is-fixed時はitemSecの位置からheaderHeightを引く
            targetPosition = elements.itemSec.offsetTop - headerHeight;
          } else {
            // is-fixed無しの時は、headMarginTopとmidashiHeightを考慮
            targetPosition = elements.itemSec.offsetTop - headerHeight - headMarginTop - midashiHeight;
          }

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        });
      }
    });
  });

  elements.midashi.addEventListener('click', toggleAccordion);
  elements.closeBtn.addEventListener('click', toggleAccordion);

  window.addEventListener('resize', function () {
    if (window.innerWidth > CONSTANTS.MOBILE_BREAKPOINT) {
      elements.midashi.classList.remove('is-open');
      $(elements.checkboxList).slideUp(0);
    }
  });

  // SP用 表示列切り替え（1列／2列）
  const layoutSwitch = document.querySelector('.layout-switch');
  const list = elements.itemSec.querySelector('.list');
  if (layoutSwitch && list) {
    const switchBtns = layoutSwitch.querySelectorAll('.switch-btn');

    function applyLayout(col) {
      list.classList.toggle('is-col2', col === '2');
      switchBtns.forEach(btn => {
        const active = btn.dataset.col === col;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    switchBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const col = this.dataset.col;
        applyLayout(col);
        try {
          localStorage.setItem('collectionLayoutCol', col);
        } catch (e) {
          // localStorageが使えない環境では保持をスキップ
        }
      });
    });

    // 保存された表示列を復元（デフォルトは1列）
    let savedCol = '1';
    try {
      savedCol = localStorage.getItem('collectionLayoutCol') || '1';
    } catch (e) {
      // 取得できなければデフォルト
    }
    applyLayout(savedCol);
  }

  // SP: stickyバー（select-sec）の固定位置を固定ヘッダーの高さに合わせる
  function updateHeaderOffset() {
    const h = elements.header.offsetHeight;
    elements.selectSec.style.top = h + 'px';
  }
  updateHeaderOffset();
  window.addEventListener('resize', updateHeaderOffset);
  window.addEventListener('load', updateHeaderOffset);

  // 初期化
  updateFixedClass();

  // URLパラメータ処理
  const urlParams = new URLSearchParams(window.location.search);
  const brandParam = urlParams.get('brandname');

  if (brandParam) {
    const loader = document.createElement('div');
    loader.className = 'loader';
    document.body.appendChild(loader);

    // 初期状態で全てのアイテムを表示状態にする
    elements.items.forEach(item => {
      item.classList.remove('hidden');
      item.classList.remove('fade-out');
    });

    setTimeout(() => {
      const targetCheckbox = document.querySelector(`input[name="designer"][value="${brandParam}"]`);
      if (targetCheckbox) {
        targetCheckbox.checked = true;
        // 直接updateItemsを呼び出す
        updateItems(brandParam);

        setTimeout(() => {
          const headerHeight = elements.header.offsetHeight;
          const selectSecHeight = elements.selectSec.offsetHeight;

          if (window.innerWidth <= CONSTANTS.MOBILE_BREAKPOINT) {
            // SP時は.item-secの位置を基準にする
            const itemSecPosition = elements.itemSec.getBoundingClientRect().top + window.pageYOffset;
            const midashiHeight = elements.midashi.offsetHeight;
            const scrollPosition = itemSecPosition - midashiHeight;

            window.scrollTo({
              top: scrollPosition - headerHeight - 40,
              behavior: 'smooth'
            });
          } else {
            // PC時はselect-secの位置を基準にする
            const selectSecPosition = elements.selectSec.getBoundingClientRect().top + window.pageYOffset;
            const scrollPosition = selectSecPosition - headerHeight;

            window.scrollTo({
              top: scrollPosition,
              behavior: 'smooth'
            });
          }
        }, CONSTANTS.FADE_DURATION);
      }

      loader.classList.add('fade-out');
      loader.addEventListener('transitionend', () => loader.remove());
    }, CONSTANTS.INITIAL_DELAY);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // .detail-secの存在チェック
  const detailSec = document.querySelector('.detail-sec');
  if (!detailSec) return; // .detail-secがない場合は処理を終了

  const photo = document.querySelector('.detail-sec .photo');
  const obj = document.querySelector('.detail-sec .obj');
  const header = document.querySelector('header');

  window.addEventListener('scroll', function () {
    // photoの位置情報を取得
    const photoRect = photo.getBoundingClientRect();
    // objの高さを取得
    const objHeight = obj.offsetHeight;
    // headerの高さを取得
    const headerHeight = header.offsetHeight;

    // photoの下端がobjの高さ分上の位置を超えたら（headerの高さを考慮）
    if (photoRect.bottom <= objHeight + headerHeight) {
      obj.classList.add('is-absolute');
    } else {
      obj.classList.remove('is-absolute');
    }
  });
});
